import { ActionPrompt } from './action-prompt';
import { AudioPlayer } from './audio';
import { EventEmitter } from './event-emitter';

export class TransportScene extends EventEmitter {
	protected sceneElements = {
		bike: document.querySelector('#bike') as any as HTMLImageElement,
		bikeActionHelper: document.querySelector('#bike-action-helper') as any as HTMLImageElement,
		bikeHandles: document.querySelector('#bike-handles') as any as HTMLImageElement,
		car: {
			container: document.querySelector('.car-container') as HTMLElement,
			brakesOn: document.querySelector('.car.brakes-on') as any as HTMLImageElement,
			brakesOff: document.querySelector('.car.brakes-off') as any as HTMLImageElement,
			shadow: document.querySelector('.car-shadow') as any as HTMLImageElement,
		},
		cow: document.querySelector('.cow') as any as HTMLImageElement,
		grass: document.querySelector('#transport-grass') as any as HTMLImageElement,
		flowers: document.querySelector('.third-flower-container') as HTMLElement,
		fox: document.querySelector('.fox-img') as any as HTMLImageElement,
		mountains: document.querySelector('#mountains') as any as HTMLImageElement,
		road: document.querySelector('#road') as any as HTMLImageElement,
		sceneContainer: document.querySelector('#transport-scene-container') as HTMLElement,
		sceneOverlay: document.querySelector('#bike-scene-overlay') as any as HTMLImageElement,
		sheep: {
			one: document.querySelector('.sheep-img.one') as any as HTMLImageElement,
			two: document.querySelector('.sheep-img.two') as any as HTMLImageElement,
		},
		smoke: {
			one: document.querySelector('.smoke-img.one') as any as HTMLImageElement,
			two: document.querySelector('.smoke-img.two') as any as HTMLImageElement,
			three: document.querySelector('.smoke-img.three') as any as HTMLImageElement,
			four: document.querySelector('.smoke-img.four') as any as HTMLImageElement,
			five: document.querySelector('.smoke-img.five') as any as HTMLImageElement,
		},
		smokeContainer: document.querySelector('.smoke-container') as HTMLElement,
		trees: {
			one: document.querySelector('.tree-img.one') as any as HTMLImageElement,
			two: document.querySelector('.tree-img.two') as any as HTMLImageElement,
			three: document.querySelector('.tree-img.three') as any as HTMLImageElement,
			four: document.querySelector('.tree-img.four') as any as HTMLImageElement,
		},
	};

	private audioPlayer = AudioPlayer.getInstance();
	private actionHelper = ActionPrompt.getInstance();

	private timeouts: any[] = [];

	public createElements(): void {
		this.sceneElements.sceneOverlay.src = './static/images/bike-scene-overlay.png';
		this.sceneElements.mountains.src = './static/images/mountains.png';
		this.sceneElements.road.src = './static/images/road.png';
		this.sceneElements.grass.src = './static/images/grass.png';
		this.sceneElements.trees.one.src = './static/images/tree.png';
		this.sceneElements.trees.two.src = './static/images/tree.png';
		this.sceneElements.trees.three.src = './static/images/tree.png';
		this.sceneElements.trees.four.src = './static/images/tree.png';
		this.sceneElements.sheep.one.src = './static/images/sheep.png';
		this.sceneElements.sheep.two.src = './static/images/sheep.png';
		this.sceneElements.smoke.one.src = './static/images/smoke-one.png';
		this.sceneElements.smoke.two.src = './static/images/smoke-two.png';
		this.sceneElements.smoke.three.src = './static/images/smoke-three.png';
		this.sceneElements.smoke.four.src = './static/images/smoke-four.png';
		this.sceneElements.smoke.five.src = './static/images/smoke-two.png';
		this.sceneElements.car.brakesOff.src = './static/images/car-brakes-off.png';
		this.sceneElements.car.brakesOn.src = './static/images/car-brakes-on.png';
		this.sceneElements.car.shadow.src = './static/images/car-shadow.png';
		this.sceneElements.bike.src = './static/images/bicycle.png';
		this.sceneElements.bikeHandles.src = './static/images/handlebars.png';
		this.sceneElements.bikeActionHelper.src = '../static/images/bicycle-action-helper.png';
		this.sceneElements.fox.src = '../static/images/fox-still.png';
		this.sceneElements.cow.src = '../static/images/cow.png';
	}

	public init(): void {
		this.sceneElements.sceneContainer.style.display = 'block';
		this.sceneElements.car.container.classList.add('full-view');
		this.sceneElements.bike.style.right = '-100%';

		this.timeouts.push(
			setTimeout(() => {
				this.audioPlayer.voiceOvers.lightSwitch.stop();
				this.audioPlayer.voiceOvers.transport.play();
				this.audioPlayer.soundFx.transportScene.carIdling.play();

				this.listenForCarClick();
			}, 2000)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.audioPlayer.soundFx.general.actionChime.play();
				this.sceneElements.bikeActionHelper.classList.add('pulse');
			}, 8000)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.actionHelper.showActionPrompt('87%', '73%');
			}, 11000)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.sceneElements.bike.click();
			}, 16000)
		);

		this.listenForBikeClick();
	}

	private listenForCarClick(): void {
		this.sceneElements.smokeContainer.style.display = 'block';

		setTimeout(() => {
			this.audioPlayer.soundFx.transportScene.carRollout.play();
			this.sceneElements.car.container.classList.add('drive-off');
		}, 1000);

		setTimeout(() => {
			this.audioPlayer.soundFx.transportScene.carIdling.stop();
			this.sceneElements.bike.style.right = '-25%';
		}, 4000);
	}

	private listenForBikeClick(): void {
		this.sceneElements.bike.addEventListener('click', () => {
			this.sceneElements.bikeActionHelper.classList.remove('pulse');
			this.actionHelper.hideActionPrompt();
			this.timeouts.forEach((timeout: any) => {
				clearTimeout(timeout);
			});

			// Start bike audio
			this.audioPlayer.soundFx.transportScene.carIdling.stop();
			this.audioPlayer.soundFx.transportScene.bikePedals.play();
			this.audioPlayer.soundFx.transportScene.birdsChirping.play();
			this.audioPlayer.soundFx.transportScene.biycleNoise.play();
			this.sceneElements.bikeHandles.style.bottom = '6%';

			setTimeout(() => {
				this.audioPlayer.soundFx.general.correctActionChime.play();
			}, 500);

			this.sceneElements.flowers.style.display = 'block';
			this.sceneElements.bike.style.right = '-100%';
			this.sceneElements.car.container.style.left = '-100%';
			this.sceneElements.sceneOverlay.style.opacity = '0';

			setTimeout(() => {
				this.sceneElements.sheep.two.style.display = 'block';
				this.sceneElements.cow.style.display = 'block';
			}, 2000);

			setTimeout(() => {
				// this.sceneElements.fox.style.display = 'none';
				this.sceneElements.sheep.one.style.display = 'none';
			}, 3000);

			setTimeout(() => {
				this.audioPlayer.soundFx.transportScene.biycleNoise.stop();
				this.audioPlayer.soundFx.transportScene.birdsChirping.stop();
				this.audioPlayer.soundFx.transportScene.bikePedals.stop();
				this.eventEmitter.dispatchEvent(new Event('finished'));
			}, 5000);
		});
	}
}
